import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { IngestInbox } from '../components/doc-ingest/IngestInbox';
import { UploadDropzone } from '../components/doc-ingest/UploadDropzone';
import { HelpButton } from '../components/help/HelpButton';
import { PageHead } from '../components/layout';
import { useActiveCompanyId } from '../lib/queries/companies';

export const Route = createFileRoute('/doc-ingest')({
  component: DocIngestInboxPage,
});

// "เอกสารถัดไป": given the current filtered/sorted inbox order and the id just
// accepted/rejected, return the next id to review (no wrap). If the current id
// already left the list (status changed → moved out of the tab), fall back to
// the first remaining id; null when nothing is left. Imported by the review
// route (/doc-ingest/$id) to advance after an accept.
export function nextIngestId(order: string[], currentId: string): string | null {
  if (order.length === 0) return null;
  const idx = order.indexOf(currentId);
  if (idx === -1) return order[0] ?? null;
  return order[idx + 1] ?? null;
}

function DocIngestInboxPage() {
  const companyId = useActiveCompanyId();
  const navigate = useNavigate();

  return (
    <div className="page">
      <PageHead
        crumbs={['เอกสาร AI', 'ตรวจเอกสาร AI']}
        title="ตรวจเอกสาร AI (Doc Ingest)"
        actions={<HelpButton guide="doc-ingest" />}
      />
      <div style={{ marginBottom: 16 }}>
        <UploadDropzone
          companyId={companyId}
          onUploaded={(id) => void navigate({ to: '/doc-ingest/$id', params: { id } })}
        />
      </div>
      <IngestInbox />
    </div>
  );
}
